const FEES_HEADERS = [
  {
    name: 'Id',
    column: 'id'
  },
  {
    name: 'Merchant',
    column: 'merchant_name'
  },
  {
    name: 'Created By',
    column: 'admin_email'
  },
  {
    name: 'Type',
    column: 'type_formatted'
  },
  {
    name: 'Value',
    column: 'value'
  },
  {
    name: 'Value Type',
    column: 'value_type_element'
  },
  {
    name: 'Created',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Updated At',
    column: 'updated_at'
  }
];

const FEE_FILTERS = [
  {
    label: 'Yearly',
    value: 'yearly'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Weekly',
    value: 'weekly'
  },
  {
    label: 'Daily',
    value: 'daily'
  }
];

const FEE_STATUSES = [
  {
    label: 'All Fees',
    value: 'all'
  },
  {
    label: 'Crypto Settlement',
    value: 'SETTLEMENT_CRYPTO'
  },
  {
    label: 'Fiat Settlement',
    value: 'SETTLEMENT_FIAT'
  },
  {
    label: 'Processing Fee',
    value: 'PROCESSING_FEE'
  },
  {
    label: 'Payout Fee',
    value: 'PAYOUT_FEE'
  }
];

export { FEES_HEADERS, FEE_FILTERS, FEE_STATUSES };
